<template>
  <v-menu
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      :return-value.sync="innerValue"
      :disabled="disabled"
      transition="scale-transition"
      offset-y
      min-width="auto"
  >
    <template v-slot:activator="{ on, attrs }">
      <!-- rules on ehdon takana jotta kentän valinta (joka aiheuttaa välittömän blur:in) ei aiheuta validointia  -->
      <v-text-field
          ref="textField"
          :value="formattedValue"
          :label="label"
          :disabled="disabled"
          :prepend-icon="prependIcon"
          :rules="menu ? [] : rules"
          :hide-details="!formattedValue"
          readonly
          clearable
          @click:clear="clearClicked"
          validate-on-blur
          v-bind="attrs"
          v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker
        v-model="d"
        no-title
        :disabled="disabled"
        :allowed-dates="computedAllowedDates"
        scrollable
        @input="handleSelectPress"
    >
<!--      <v-spacer></v-spacer>-->
<!--      <v-btn-->
<!--          text-->
<!--          color="primary"-->
<!--          @click="menu = false"-->
<!--      >-->
<!--        {{ $t('cancel') }}-->
<!--      </v-btn>-->
<!--      <v-btn-->
<!--          text-->
<!--          color="primary"-->
<!--          @click="handleSelectPress"-->
<!--      >-->
<!--        {{ $t('select') }}-->
<!--      </v-btn>-->
    </v-date-picker>
  </v-menu>
</template>

<script>
import dayjs from "dayjs";

export default {
  props: ['value', 'label', 'prependIcon', 'rules', 'allowedDates', 'allowPastDates', 'disabled'],
  emits: ['input'],
  name: 'MenuDatePicker',
  data() {
    return {
      menu: false,
      innerValue: this.value,
      d: this.value,
    }
  },
  computed: {
    computedAllowedDates() {
      if (this.allowedDates)
        return this.allowedDates;

      if (this.allowPastDates === false) {
        return (d) => new Date(d).getTime() > new Date().getTime();
      }

      return null;
    },
    formattedValue() {
      if (!this.innerValue) {
        return '';
      }

      const date = new Date(this.innerValue);

      // Use the browser's default locale, or pass in a specific locale if needed.

      const language = this.$user.language || 'fi';

      const formattedDate = new Intl.DateTimeFormat(language, {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
      }).format(date);

      return formattedDate;
    }
  },
  watch: {
    innerValue(to) {
      if (to !== this.value) {
        this.$emit('input', to);
      }
    },
    value(to) {
      this.d = to;
      this.innerValue = to;
    },
  },
  methods: {
    clearClicked() {
      this.$refs.textField.blur();
      this.$refs.textField.reset();
      this.d = null;
      this.innerValue = null;
    },
    handleSelectPress() {
      this.$refs.menu.save(this.d)
      setTimeout(() => {
        this.$refs.textField.validate(); // Pakotetaan validointi valinnassa jotta se tulee tehtyä. Ja timeout juttu on jotta se oikeasti tulee tietojen muuttumisen jälkeen
      }, 1)
    }
  }
}
</script>

<style scoped>

</style>
